angular.module('v3sWbtPlayerApp').directive('v3sBreadcrumbDirective', ['$timeout', 'v3sNavigationService', function ($timeout, v3sNavigationService) {
    return {
        restrict: 'EA',
        templateUrl: "app/js/navigation/navbar/breadcrumb.tpl.html",
        scope: {
            'goTo': '&',
            'showTree': '&',
            'page': '='
            
        },
        controller: ["$scope", function ($scope) {
            //create breadcrumb
            $scope.breadcrumb = [];
            var item = $scope.page;

            if (item.type === "structureSco" && !!item.treeChildren && item.treeChildren.length > 0) {
                item = item.children[0];
            }

            while (!!item.getTreeParent()) {

                var parent = item.getTreeParent();
                var items = parent.getChildren();

                if (!item.hiddenItem || !!parent.treeChildren) { //struktur-sco ohne Kinder

                    var point = {};
                    point.selected = item;

                    if (!!item.hiddenItem) {
                        item.title = "other.please_select";
                    }

                    point.items = [];

                    for (var i = 0; i < items.length; i++) {
                        if (!items[i].treeParent || items[i].treeParent == parent) {
                            var dropdownItem = {
                                'item': items[i],
                                'href': v3sNavigationService.getHref(v3sNavigationService.getPageState(items[i]))
                            };
                            point.items.push(dropdownItem);
                        }
                    }

                    $scope.breadcrumb.unshift(point);
                }
                if ($scope.breadcrumb.length > 2 && !!item.sco) {
                    break;
                } else {
                    item = parent;
                }
                
            }
        }],
        link: function (scope, element, attrs) {
            //DOM completed
            $timeout(function () {
                $timeout(function () {
                    try {
                        var breadcrumb = element[0];
                        var length = breadcrumb.children.length;
                        
                        var index = 0;
                        var btn = breadcrumb.children[index];

                        while (breadcrumb.offsetTop >= btn.offsetHeight && index < length) {
                            angular.element(btn).addClass('hideText');
                            btn = breadcrumb.children[++index];
                        }
                    } catch (e) {
                    }
                }, 0);
            }, 0);
        }
    }
}]);